/**
 * COMPONENT: ComplexFormulaPopup.jsx
 * Permite definir fórmulas complejas de tarifas derivadas.
 * Envía datos al endpoint PUT /api/derived-rates/:id/formula
 */

import React, { useState, useEffect } from "react";
import axios from "../api/axiosInstance";

export default function ComplexFormulaPopup({ formData, onClose }) {
  const [loading, setLoading] = useState(false);
  const [baseRates, setBaseRates] = useState([]);
  const [inputs, setInputs] = useState([{ base_rate_id: null, weight: 1 }]);
  const [formulaType, setFormulaType] = useState("average");
  const hasLegacyCustomFormula =
    formData?.room_rate?.formula_type === "custom";
  const [adjustmentType, setAdjustmentType] = useState("percent");
  const [adjustmentValue, setAdjustmentValue] = useState(0);
  // 🧩 Custom expression reemplazado por builder visual
    const [formulaBlocks, setFormulaBlocks] = useState([]);

    const removeBlock = (i) =>
    setFormulaBlocks((prev) => prev.filter((_, idx) => idx !== i));

    const clearFormula = () => setFormulaBlocks([]);

    // === 🔹 Estados para modales ===
    const [showRateModal, setShowRateModal] = useState(false);
    const [showOperatorModal, setShowOperatorModal] = useState(false);
    const [showNumberModal, setShowNumberModal] = useState(false);

    // === 🔹 Abrir modales ===
    const openRateModal = () => setShowRateModal(true);
    const openOperatorModal = () => setShowOperatorModal(true);
    const openNumberModal = () => setShowNumberModal(true);

    // === 🔹 Cerrar modales ===
    const closeAllModals = () => {
    setShowRateModal(false);
    setShowOperatorModal(false);
    setShowNumberModal(false);
    setTempNumber("");
    };

    // === 🔹 Añadir desde modales ===
    const selectRate = (r) => {
    console.log("[Builder] Added rate:", r.rate_code || r.name, "| id:", r.id);
    setFormulaBlocks((prev) => [
        ...prev,
        {
        type: "rate",
        value: r.rate_code || r.name,
        id: r.id, // 🧩 Guarda el ID real para el backend
        },
    ]);
    closeAllModals();
    };

    const selectOperator = (op) => {
    const last = formulaBlocks[formulaBlocks.length - 1];

    // ✅ Paréntesis no necesitan validación de operadores consecutivos
    if (!["(", ")"].includes(op)) {
        if (last?.type === "operator" && !["(", ")"].includes(last?.value)) {
        alert("Cannot place two operators consecutively.");
        return;
        }
    }

    const blockType = ["(", ")"].includes(op)
        ? "parenthesis"
        : "operator";

    console.log("🟢 [selectOperator] Added:", { type: blockType, value: op });

    setFormulaBlocks((prev) => [...prev, { type: blockType, value: op }]);
    closeAllModals();
    };


    const [tempNumber, setTempNumber] = useState("");

    const addNumberDigit = (n) => {
    setTempNumber((prev) => prev + n);
    };

    const applyNumber = () => {
    if (!tempNumber.trim()) return;
    console.log("[Builder] Added number:", tempNumber);
    setFormulaBlocks((prev) => [...prev, { type: "number", value: tempNumber }]);
    closeAllModals();
    };




  // 🧭 Cargar tarifas base disponibles (misma BU)
  // 🧭 Cargar tarifas base disponibles (idéntico al popup funcional)
    useEffect(() => {
    if (!formData?.baseCandidates?.length) {
        console.warn("[ComplexFormulaPopup] No baseCandidates provided from parent component.");
        return;
    }

    // 🔁 Reutiliza exactamente los mismos candidatos filtrados del popup simple
    const current = formData?.room_rate;
    const filtered = (formData.baseCandidates || []).filter(
        (r) =>
        r.id !== current?.id &&
        r.currency === current?.currency &&
        !r.base_rate_id
    );

    const uniqueByGroup = Array.from(
        new Map(filtered.map((r) => [r.group_key || r.id, r])).values()
    );

    setBaseRates(uniqueByGroup);
    console.log("[ComplexFormulaPopup] Using parent baseCandidates:", uniqueByGroup.length);
    }, [formData]);




  // ➕ Añadir una línea de input
  const addInput = () =>
    setInputs((prev) => [...prev, { base_rate_id: null, weight: 1 }]);

  // 🗑️ Eliminar línea
  const removeInput = (idx) =>
    setInputs((prev) => prev.filter((_, i) => i !== idx));

  // 🧠 Guardar
  // 🧠 Guardar (actualizado)
const handleSave = async () => {
  const id = formData?.room_rate?.id;
  if (!id) return alert("Missing rate ID.");

  try {
    setLoading(true);

    // 🧩 Si es modo custom, convertir los bloques a texto antes de enviar
    let finalExpression = null;
    let normalizedInputs = inputs;

    if (formulaType === "custom") {
      if (!formulaBlocks.length) return alert("Custom formula is empty.");

      // Generar expresión legible
      finalExpression = formulaBlocks.map((b) => b.value).join(" ");

      // Generar inputs automáticamente desde los bloques (solo los que tienen id)
      normalizedInputs = formulaBlocks
        .filter((b) => b.type === "rate" && b.id)
        .map((b) => ({
          base_rate_id: Number(b.id),
          weight: 1,
        }));

      console.log("[Custom] Autogenerated inputs from formulaBlocks:", normalizedInputs);
    }

    // Validación final
    if (!normalizedInputs.length || normalizedInputs.some((i) => !i.base_rate_id)) {
      alert("Please select at least one valid base rate.");
      setLoading(false);
      return;
    }

    console.log("[ComplexFormulaPopup] PUT payload:", {
      formula_type: formulaType,
      adjustment_type: adjustmentType,
      adjustment_value: adjustmentValue,
      inputs: normalizedInputs,
      custom_expression: finalExpression,
    });

    await axios.put(`/api/derived-rates/${id}/formula`, {
      formula_type: formulaType,
      adjustment_type: adjustmentType,
      adjustment_value: adjustmentValue,
      inputs: normalizedInputs,
      custom_expression: finalExpression,
    });

    alert("Formula saved.");
    onClose();
    window.location.reload();
  } catch (err) {
    console.error("[ComplexFormulaPopup] Error:", err);
    alert(err?.response?.data?.error || "Error saving formula.");
  } finally {
    setLoading(false);
  }
};



  console.log("🧠 RENDER ComplexFormulaPopup");
    console.log("📊 STATES:", {
    showRateModal,
    showOperatorModal,
    showNumberModal,
    formulaBlocks,
    tempNumber,
    });


  return (
    <div
    className="erp-formulaPopup"
    style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "var(--erp-overlay, rgba(7,15,36,0.78))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    }}
    onClick={(e) => {
        // 🔥 evita que los clicks dentro de modales hijos cierren el popup principal
        if (e.target.classList.contains("modal-backdrop")) return;
        e.stopPropagation();
    }}
    >

      <div
        className="erp-formulaShell"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 580,
          maxWidth: "95%",
          maxHeight: "calc(100dvh - 28px)",
          overflowY: "auto",
          background: "var(--erp-modal-bg, #0e1730)",
          border: "1px solid var(--erp-modal-border, rgba(92,134,181,0.34))",
          borderTop: "3px solid #3db6e9",
          borderRadius: 16,
          padding: 20,
          color: "var(--erp-modal-text, #dfe8f7)",
          boxShadow: "var(--erp-modal-shadow, 0 24px 54px rgba(2,8,28,.52))",
        }}
      >
        <h4 className="mb-3 erp-formulaTitle">Advanced Derived Formula</h4>

        {/* Formula Type */}
        <div className="mb-3">
          <label className="form-label">Formula Type</label>
          <select
            className="form-select"
            value={formulaType}
            onChange={(e) => setFormulaType(e.target.value)}
          >
            <option value="average">Average (mean of all bases)</option>
            <option value="min">Minimum (lowest price)</option>
            <option value="max">Maximum (highest price)</option>
            <option value="weighted">Weighted average</option>
          </select>
        </div>

        {hasLegacyCustomFormula && (
          <div className="alert alert-warning py-2" role="alert">
            This rate uses a legacy custom formula. It remains unchanged until
            you unlink it or replace it with a supported formula; custom
            formulas cannot currently be evaluated safely.
          </div>
        )}

        {/* Base Rate Inputs */}
        {formulaType !== "custom" && (
        <div className="mb-3">
            <label className="form-label">Base Rates</label>
            {inputs.map((inp, idx) => (
            <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                <select
                className="form-select"
                style={{ flex: 2 }}
                value={inp.base_rate_id || ""}
                onChange={(e) =>
                    setInputs((prev) =>
                    prev.map((p, i) =>
                        i === idx
                        ? { ...p, base_rate_id: Number(e.target.value) || null }
                        : p
                    )
                    )
                }
                >
                <option value="">-- Select rate --</option>
                {baseRates.map((r) => (
                    <option key={r.id} value={r.id}>
                    {r.name} ({r.rate_code})
                    </option>
                ))}
                </select>

                {formulaType === "weighted" && (
                <input
                    type="number"
                    step="0.1"
                    className="form-control text-center"
                    style={{ width: "80px" }}
                    value={inp.weight}
                    onChange={(e) =>
                    setInputs((prev) =>
                        prev.map((p, i) =>
                        i === idx
                            ? { ...p, weight: Number(e.target.value) || 0 }
                            : p
                        )
                    )
                    }
                />
                )}

                <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => removeInput(idx)}
                >
                ×
                </button>
            </div>
            ))}
            <button
            className="btn btn-sm btn-outline-info mt-2"
            onClick={addInput}
            >
            + Add Base Rate
            </button>
        </div>
        )}


        {/* Custom Expression */}
        {formulaType === "custom" && (
          <div className="mb-3">
            <label className="form-label">Custom Expression</label>
            {/* 🧮 Visual Formula Builder */}
            <div className="erp-formulaBuilder p-3 rounded-3">
            {/* Bloques visibles */}
            <div className="d-flex flex-wrap gap-2 mb-3">
                {formulaBlocks.map((block, i) => (
                <span
                    key={i}
                    className="erp-formulaToken badge fs-6 px-3 py-2 d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeBlock(i)}
                >
                    {block.value}
                    <span className="ms-2 text-danger fw-bold">×</span>
                </span>
                ))}
            </div>

            {/* Controles de creación */}
            <div className="d-flex flex-wrap gap-2 mb-2">
                <button className="btn btn-outline-info btn-sm" onClick={openRateModal}>
                + Add Rate
                </button>
                <button className="btn btn-outline-info btn-sm" onClick={openOperatorModal}>
                + Add Operator
                </button>
                <button className="btn btn-outline-info btn-sm" onClick={openNumberModal}>
                + Add Number
                </button>

                <button className="btn btn-outline-danger btn-sm" onClick={clearFormula}>
                Clear
                </button>
            </div>

            {/* Vista previa */}
            <div className="erp-formulaPreview small mt-2">
                <strong>Preview:</strong>{" "}
                {formulaBlocks.map((b) => b.value).join(" ") || "— empty —"}
            </div>
            </div>

           
          </div>
        )}

        {/* Adjustment */}
        <div
          className="mb-3 d-flex align-items-center justify-content-between"
          style={{ gap: 8 }}
        >
          <div style={{ flex: 1 }}>
            <label className="form-label">Adjustment Type</label>
            <select
              className="form-select"
              value={adjustmentType}
              onChange={(e) => setAdjustmentType(e.target.value)}
            >
              <option value="percent">Percent</option>
              <option value="absolute">Absolute</option>
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label className="form-label">Adjustment Value</label>
            <input
              type="number"
              className="form-control"
              value={adjustmentValue}
              onChange={(e) => setAdjustmentValue(Number(e.target.value))}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="btn btn-sm"
            onClick={onClose}
            style={{
              border: "1px solid var(--erp-modal-border-strong, rgba(61,182,233,.58))",
              color: "var(--erp-modal-text, #dfe8f7)",
              background: "var(--erp-modal-section, #121f3d)",
            }}
          >
            Cancel
          </button>

          <button
            className="btn btn-sm"
            onClick={handleSave}
            disabled={loading}
            style={{
              border: "1px solid #3db6e9",
              color: "#fff",
              background: "#223a7a",
            }}
          >
            {loading ? "Saving…" : "Save Formula"}
          </button>
          </div>

          {/* === Rate Modal === */}
            {showRateModal && (
            <div
                className="modal-backdrop"
                onClick={(e) => {
                // Solo cerrar si el click es directamente sobre el fondo
                if (e.target === e.currentTarget) {
                    console.log("🟥 Click on backdrop → closeAllModals()");
                    closeAllModals();
                } else {
                    console.log("🟩 Click inside Rate modal → ignored");
                }
                }}
                style={{
                position: "fixed",
                inset: 0,
                background: "var(--erp-overlay, rgba(7,15,36,0.78))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10001,
                }}
            >
                {/* 🔹 Añadimos position:relative aquí */}
                <div
                className="modal-dialog erp-formulaMiniModal p-3 rounded"
                style={{
                    maxWidth: 400,
                    position: "relative",
                    zIndex: 10002, // <<– más alto que el fondo
                    pointerEvents: "auto", // <<– importante
                }}
                >
                <h5 className="mb-3">Select a Rate</h5>
                <div className="d-flex flex-column gap-2">
                    {baseRates.map((r) => (
                    <button
                        key={r.id}
                        className="btn btn-outline-info"
                        style={{ pointerEvents: "auto" }} // <<– fuerza el click
                        onClick={() => {
                        console.log("🟢 BUTTON Rate clicked", r.name);
                        selectRate(r);
                        }}
                    >
                        {r.name} ({r.rate_code})
                    </button>
                    ))}
                </div>
                <button
                    className="btn btn-outline-secondary mt-3 w-100"
                    onClick={() => {
                    console.log("🟥 Cancel pressed (Rate modal)");
                    closeAllModals();
                    }}
                >
                    Cancel
                </button>
                </div>
            </div>
            )}






            {showOperatorModal && (
            <div
                className="modal-backdrop"
                onClick={(e) => {
                if (e.target === e.currentTarget) {
                    console.log("🟥 Click on backdrop (Operator) → closeAllModals()");
                    closeAllModals();
                } else {
                    console.log("🟩 Click inside Operator modal → ignored");
                }
                }}
                style={{
                position: "fixed",
                inset: 0,
                background: "var(--erp-overlay, rgba(7,15,36,0.78))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10001,
                }}
            >
                <div
                className="modal-dialog erp-formulaMiniModal p-3 rounded"
                style={{
                    maxWidth: 250,
                    position: "relative",
                    zIndex: 10002,
                    pointerEvents: "auto",
                }}
                >
                <h5 className="mb-3 text-center">Select Operator</h5>

                <div className="d-flex flex-wrap justify-content-center gap-2">
                    {["+", "-", "*", "/", "(", ")"].map((op) => (
                    <button
                        key={op}
                        className="btn btn-outline-info fs-4 px-3"
                        style={{ pointerEvents: "auto" }}
                        onClick={() => {
                        console.log("🟢 BUTTON Operator/Paren clicked", op);
                        selectOperator(op);
                        }}
                    >
                        {op}
                    </button>
                    ))}
                </div>

                <button
                    className="btn btn-outline-secondary mt-3 w-100"
                    onClick={() => {
                    console.log("🟥 Cancel pressed (Operator modal)");
                    closeAllModals();
                    }}
                >
                    Cancel
                </button>
                </div>
            </div>
            )}





            {showNumberModal && (
            <div
                className="modal-backdrop"
                onClick={(e) => {
                if (e.target === e.currentTarget) {
                    console.log("🟥 Click on backdrop (Number) → closeAllModals()");
                    closeAllModals();
                } else {
                    console.log("🟩 Click inside Number modal → ignored");
                }
                }}
                style={{
                position: "fixed",
                inset: 0,
                background: "var(--erp-overlay, rgba(7,15,36,0.78))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10001,
                }}
            >
                <div
                className="modal-dialog erp-formulaMiniModal p-3 rounded text-center"
                style={{
                    maxWidth: 250,
                    position: "relative",
                    zIndex: 10002,
                    pointerEvents: "auto",
                }}
                >
                <h5 className="mb-3">Enter Number</h5>
                <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((n) => (
                    <button
                        key={n}
                        className="btn btn-outline-info fs-5 px-3"
                        style={{ pointerEvents: "auto" }}
                        onClick={() => {
                        console.log("🟢 BUTTON Number clicked", n);
                        addNumberDigit(n);
                        }}
                    >
                        {n}
                    </button>
                    ))}
                </div>
                <div className="erp-formulaPreview mb-2">{tempNumber || "—"}</div>
                <button
                    className="btn btn-outline-success w-100 mb-2"
                    onClick={() => {
                    console.log("🟢 Apply Number pressed");
                    applyNumber();
                    }}
                >
                    Apply
                </button>
                <button
                    className="btn btn-outline-secondary w-100"
                    onClick={() => {
                    console.log("🟥 Cancel pressed (Number modal)");
                    closeAllModals();
                    }}
                >
                    Cancel
                </button>
                </div>
            </div>
            )}




        
      </div>
    </div>
  );
}
